<template>
  <div class="crm-alert" :class="`crm-alert--${color}`" role="alert">
    <i :class="iconMap[color] || 'fas fa-info-circle'" class="crm-alert__icon"></i>
    <span class="crm-alert__text"><slot /></span>
    <button v-if="dismissible" class="crm-alert__close" @click="$emit('close')" aria-label="Cerrar">
      <i class="fas fa-times"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SoftAlert',
  props: {
    color: { type: String, default: 'success' },
    icon: { type: String, default: '' },
    dismissible: { type: Boolean, default: false },
  },
  emits: ['close'],
  data() {
    return {
      iconMap: {
        success: 'fas fa-check-circle',
        danger:  'fas fa-exclamation-circle',
        warning: 'fas fa-exclamation-triangle',
        info:    'fas fa-info-circle',
        primary: 'fas fa-bell',
      },
    }
  },
}
</script>

<style scoped>
.crm-alert {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.83rem;
  font-weight: 500;
  margin-bottom: 16px;
}

.crm-alert__icon { font-size: 1rem; flex-shrink: 0; }

.crm-alert__text { flex: 1; line-height: 1.4; }

.crm-alert__close {
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.6;
  font-size: 0.8rem;
  padding: 0;
  color: inherit;
  transition: opacity 0.15s ease;
  flex-shrink: 0;
}
.crm-alert__close:hover { opacity: 1; }

/* Variants */
.crm-alert--success { background: #ECFDF5; color: #065F46; }
.crm-alert--danger  { background: #FEF2F2; color: #991B1B; }
.crm-alert--warning { background: #FFFBEB; color: #92400E; }
.crm-alert--info    { background: #E0F2FE; color: #075985; }
.crm-alert--primary { background: #EFF6FF; color: #1E40AF; }
</style>
